export const CREATE_CSS_ASSET = 'CREATE_CSS_ASSET'
export const CREATE_CSS_ASSET_SUCCESS = 'CREATE_CSS_ASSET_SUCCESS'
export const CREATE_CSS_ASSET_FAILURE = 'CREATE_CSS_ASSET_FAILURE'
export const UPDATE_CSS_ASSET_URL = "UPDATE_CSS_ASSET_URL";
export const DELETE_CSS_ASSET_URL = "DELETE_CSS_ASSET_URL";
export const FETCH_ASSET = 'FETCH_ASSET'
export const FETCH_ASSET_SUCCESS = 'FETCH_ASSET_SUCCESS'
export const FETCH_ASSET_FAILURE = 'FETCH_ASSET_FAILURE'

export const CREATE_IMAGE_ASSET = "CREATE_IMAGE_ASSET"
export const DELETE_IMAGE_ASSET = "DELETE_IMAGE_ASSET";
export const CREATE_FONT_ASSET = "CREATE_FONT_ASSET"
export const DELETE_FONT_ASSET = "DELETE_FONT_ASSET";

export const CREATE_JSON_ASSET = "CREATE_JSON_ASSET";
export const DELETE_JSON_ASSET = "DELETE_JSON_ASSET";

export type FontType = {
    category: string;
    family: string;
    files: Object;
    kind: string;
    lastModified: string;
    menu: string;
    subsets: string[];
    variants: string[];
    version: string;
}

export interface IStaticAssets {
    css: {},
    images: {},
    fonts: {},
    json: {},
    status: string
}

export type staticAssetActionTypes = {
    type: typeof CREATE_CSS_ASSET | 
        typeof CREATE_CSS_ASSET_SUCCESS | 
        typeof CREATE_CSS_ASSET_FAILURE | 
        typeof FETCH_ASSET | 
        typeof FETCH_ASSET_SUCCESS | 
        typeof FETCH_ASSET_FAILURE | 
        typeof CREATE_IMAGE_ASSET | 
        typeof DELETE_IMAGE_ASSET |
        typeof CREATE_FONT_ASSET | 
        typeof DELETE_FONT_ASSET |
        typeof UPDATE_CSS_ASSET_URL | 
        typeof DELETE_CSS_ASSET_URL |
        typeof CREATE_JSON_ASSET |
        typeof DELETE_JSON_ASSET,
    data: any;
}